import axios from 'axios'
const API_URL = "https://blooggerr.onrender.com/"
// const API_URL = "http://localhost:8080/"

function registerUser(data){
    return axios.post(API_URL+'register', data)
}

function loginUser(data){
    return axios.post(API_URL+'login', data)
}

function verifyOtp(data){
    return axios.post(API_URL+'login/verify-otp', data)
}

function getUser(id, _headers){
    console.log(1,_headers)
    return axios.get(`${API_URL}account/${id}`, {headers: _headers})
}

function getBookmarkedBlogs(_headers){
    console.log("account/bookmarks")
    return axios.get(API_URL+'account/bookmarks', {headers: _headers})
}

function getMyBlogs(_headers){
    console.log("account/myBlogs")
    return axios.get(API_URL+'account/myBlogs', {headers: _headers})
}

function updateProfile(data, _headers){
    return axios.post(API_URL+'account/update-profile', data, {headers: _headers})
}

function changePassword(data, _headers){
    return axios.post(API_URL+'account/change-password', data, {headers: _headers})
}




export {registerUser, loginUser, getUser, updateProfile, changePassword, verifyOtp, getBookmarkedBlogs, getMyBlogs}
